import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amount", "reason"]
  static values = {
    standardAmount: String,
    organizerAmount: String,
    organizerReason: String
  }

  connect() {
    this.previousReason = this.reasonTarget.value
    this.ordinaryAmount = this.organizerReasonSelected
      ? this.standardAmountValue
      : this.amountTarget.value
    if (this.organizerReasonSelected) this.amountTarget.value = this.organizerAmountValue
    this.updateMaximum()
  }

  update() {
    const wasOrganizerReason = this.previousReason === this.organizerReasonValue

    if (!wasOrganizerReason) this.ordinaryAmount = this.amountTarget.value

    if (this.organizerReasonSelected) {
      this.amountTarget.value = this.organizerAmountValue
    } else if (wasOrganizerReason) {
      this.amountTarget.value = this.ordinaryAmount
    }

    this.updateMaximum()
    this.previousReason = this.reasonTarget.value
  }

  get organizerReasonSelected() {
    return this.reasonTarget.value === this.organizerReasonValue
  }

  updateMaximum() {
    this.amountTarget.max = this.organizerReasonSelected
      ? this.organizerAmountValue
      : this.standardAmountValue
  }
}
